<template>
  <span class="svg-icon-grid-view">
    <svg class="icon-color-1" :style="`width:${width}px; height:${width}px; fill:none;`" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.825906 4.19684C-0.0361408 2.21543 1.41602 0 3.57683 0L15 0V25H3.75268C1.54734 25 0.0957718 22.7004 1.04443 20.7095L4.09756 14.3021C4.47107 13.5183 4.48664 12.611 4.14023 11.8148L0.825906 4.19684Z" :fill="color"/>
      <!-- <path d="M9.82591 4.19684C8.96386 2.21543 10.416 0 12.5768 0L24 0V25H12.7527C10.5473 25 9.09577 22.7004 10.0444 20.7095L13.0976 14.3021C13.4711 13.5183 13.4866 12.611 13.1402 11.8148L9.82591 4.19684Z" :fill="color"/> -->
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 15 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } }
  }
}
</script>
